<template>
  <b-card tag="article" v-bind:class="color">
    <div class="badge" v-if="status" v-bind:class="`badge-${color}`">
      {{ getReadableStatus(status) }}
    </div>
    <b-card-title>
      {{ name }}
    </b-card-title>
    <b-card-text class="text-left mt-3" v-if="code">
      {{ code }}
    </b-card-text>
  </b-card>
</template>
<script>
import { PROGRAM_STATUS, getReadableProgramStatus } from '../models/programStatus'
export default {
  name: 'ProgramCard',
  props: ['name', 'code', 'order', 'link', 'status', 'color'],
  methods: {
    getReadableStatus: function(status) {
      return getReadableProgramStatus(status)
    },
    getStatusColor: function(status) {
      switch (status) {
        case PROGRAM_STATUS.REGISTRATION_OPEN:
          return 'green'
        case PROGRAM_STATUS.REGISTRATION_CLOSED:
          return 'red'
        case PROGRAM_STATUS.PREQUALIFICATION_CLOSED:
          return 'red'
        case PROGRAM_STATUS.PREQUALIFICATION_OPEN:
          return 'green'
      }
    }
  }
}
</script>
<style scoped>
.card:before {
  content: ' ';
  display: block;
  position: absolute;
  left: auto;
  right: auto;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.7;
  background-image: url('../../../assets/img/logo/vekonyvali_hollow_outline.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
}
.card {
  height: 365px;
}
.card.red:before {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.card.blue:before {
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
.card-body {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
}

.card.green {
  background-color: var(--color-green) !important;
}

.card.red {
  background-color: var(--color-red) !important;
}

.card.blue {
  background-color: var(--color-blue) !important;
}

.card-text,
.card-title {
  color: white !important;
}

.card-title {
  font-size: 32px;
  text-align: left !important;
  font-weight: bold;
}

.card-body {
  padding: 0.25rem !important;
  padding-bottom: 1.25rem !important;
  padding-top: 1.25rem !important;
  text-align: center;
}

.badge .badge-text {
  /*transform: rotate(-45deg);
  margin-top: 15px;*/
  margin-top: 6px;
  margin-left: -8px;
}

.add-button {
  width: inherit;
}

p {
  text-align: left;
  margin-bottom: 3px;
}
.badge {
  position: absolute;
  width: 60%;
  height: 50px;
  background: var(--color-lightblue);
  left: -1px;
  top: -1px;
  border-bottom-right-radius: 100px;
  border-top-left-radius: 7px;
  padding-top: 15px;
  padding-right: 0;
  padding-left: 0;
  border-width: 0px;
  border-style: solid;
  font-size: 16px;
}

.badge.badge-green {
  border-color: #00903c;
  color: #00903c;
}

.badge.badge-red {
  border-color: #ba3b46;
  color: #ba3b46;
}

.badge .badge-text {
  /*transform: rotate(-45deg);
  margin-top: 15px;*/
  margin-top: 6px;
  margin-left: -8px;
}
</style>
